/* "Where is my VIN?" opens on click, not on hover.

   The popup is a two picture lightbox centred on the screen. Opening it on
   hover meant it appeared whenever the pointer crossed the link on its way to
   the VIN field, and vanished the moment the pointer left the link, so it
   could not be read comfortably. It now opens on a click (or Enter / Space),
   dims the page behind it, and closes on the close button, a click outside,
   Escape, or a second click on the link. fx-where.css switches off the
   extension's hover and focus opening, which is pure CSS and cannot be
   unbound from here.

   Delegated from the document, so it survives anything re-rendering the hero. */
(function () {
  'use strict';

  var PLATE_FILE = 'futura-vin-plate-2026-10';
  var PLATE_SRC = 'https://cdn.shopify.com/s/files/1/0963/8327/1200/files/futura-vin-plate-2026-10.jpg?v=1793155443&width=1200';

  var CLOSE_SVG =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 3.5l9 9m0-9l-9 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function prepare(wrap) {
    if (wrap.getAttribute('data-fx-where')) return;
    wrap.setAttribute('data-fx-where', '1');
    var btn = wrap.querySelector('.vin-hero-where-btn');
    var pop = wrap.querySelector('.vin-hero-where-pop');
    if (!btn || !pop) return;

    btn.removeAttribute('aria-describedby');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-haspopup', 'dialog');
    if (pop.id) btn.setAttribute('aria-controls', pop.id);

    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');
    pop.setAttribute('aria-label', (btn.textContent || 'Where is my VIN?').trim());
    pop.setAttribute('tabindex', '-1');

    if (!pop.querySelector('.fx-where-close')) {
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'fx-where-close';
      x.setAttribute('aria-label', 'Close');
      x.innerHTML = CLOSE_SVG;
      pop.insertBefore(x, pop.firstChild);
    }
    /* THE EXAMPLE PLATE IS OURS TO SET, AND THE EXTENSION'S COPY IS NOT IT.
       The popup's markup comes from the app extension, so the picture it ships
       cannot be changed from the theme the way a stylesheet can. Swapping the
       src here is the one hook we have. PLATE_SRC is a Shopify Files URL
       rather than a theme asset because this file is a static asset and has no
       Liquid to resolve asset_url with; a Files URL is permanent and survives
       every theme duplication. Guarded on the filename so a re-render does not
       set it twice and so the day the extension ships this picture itself,
       this quietly stops doing anything. */
    var plate = pop.querySelector('.vin-hero-where-plate');
    if (plate && String(plate.getAttribute('src') || '').indexOf(PLATE_FILE) === -1) {
      plate.setAttribute('src', PLATE_SRC);
      plate.setAttribute('alt', 'The VIN plate on the drawbar, with the last 5 digits circled');
      plate.removeAttribute('srcset');
    }

    if (!wrap.querySelector('.fx-where-scrim')) {
      var s = document.createElement('span');
      s.className = 'fx-where-scrim';
      s.setAttribute('aria-hidden', 'true');
      wrap.insertBefore(s, pop);
    }
  }

  function openOne() {
    return document.querySelector('.vin-hero-where.is-open');
  }

  function open(wrap) {
    prepare(wrap);
    wrap.classList.add('is-open');
    var btn = wrap.querySelector('.vin-hero-where-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var x = wrap.querySelector('.fx-where-close');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 0);
  }

  function close(wrap, returnFocus) {
    if (!wrap) return;
    wrap.classList.remove('is-open');
    var btn = wrap.querySelector('.vin-hero-where-btn');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      if (returnFocus) btn.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('.vin-hero-where-btn');
    if (btn) {
      var wrap = btn.closest('.vin-hero-where');
      if (!wrap) return;
      e.preventDefault();
      if (wrap.classList.contains('is-open')) close(wrap, true);
      else open(wrap);
      return;
    }

    var current = openOne();
    if (!current) return;
    if (t.closest('.fx-where-close') || t.closest('.fx-where-scrim')) {
      e.preventDefault();
      close(current, true);
      return;
    }
    if (!t.closest('.vin-hero-where-pop')) close(current, false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var current = openOne();
    if (current) close(current, true);
  });

  function start() {
    var list = document.querySelectorAll('.vin-hero-where');
    for (var i = 0; i < list.length; i++) prepare(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
